import React, { forwardRef } from 'react';
import useMediaEnd from '../hooks/useMediaEnd';

interface VideoPlayerProps {
  src: string;
  type?: string;
  className?: string;
  autoPlay?: boolean;
  controls?: boolean;
}

const VideoPlayer: React.ForwardRefRenderFunction<HTMLVideoElement, VideoPlayerProps> = ({ src, type, className, autoPlay, controls }, ref) => {

  const endVideo = useMediaEnd();

  return (
      <video ref={ref}  controls={controls} autoPlay={autoPlay} onEnded={endVideo} className={className}>
        <source src={ src } type={ type || "video/mp4" } />
      </video>
  )
}

export default forwardRef(VideoPlayer);